export enum TimesheetQueryReasonType {
	IncorrectDays = "Incorrect working days",
	IncorrectHours = "Incorrect working hours",
	Other = "Other",
}
